import { AnyAction } from 'redux';

import { getMerchants, Merchants } from '@ttstr/api';
import { getMerchantsReceived } from '@ttstr/reducers/merchants';

import { ThunkActionCreator } from '.';

export const MERCHANTS_REQUESTED = 'MERCHANTS.MERCHANTS_REQUESTED';
export const MERCHANTS_ALREADY_RECEIVED = 'MERCHANTS.MERCHANTS_ALREADY_RECEIVED';
export const MERCHANTS_RECEIVED = 'MERCHANTS.MERCHANTS_RECEIVED';
export const MERCHANTS_FAILED = 'MERCHANTS.MERCHANTS_FAILED';

export interface MerchantsReceivedAction extends AnyAction {
  payload: {
    merchants: Merchants;
  };
}

let requestMerchantsAbortController: AbortController;
export const requestMerchants: ThunkActionCreator = () => async (dispatch, getState) => {
  if (requestMerchantsAbortController) requestMerchantsAbortController.abort();

  requestMerchantsAbortController = new AbortController();
  dispatch({
    type: MERCHANTS_REQUESTED,
  });

  try {
    // TODO This "cache" needs to be invalidated eventually
    if (getMerchantsReceived(getState())) {
      dispatch({
        type: MERCHANTS_ALREADY_RECEIVED,
      });
      return;
    }

    const merchants = await getMerchants({ signal: requestMerchantsAbortController.signal });
    dispatch<MerchantsReceivedAction>({
      type: MERCHANTS_RECEIVED,
      payload: {
        merchants,
      },
    });
  } catch (error) {
    dispatch({
      type: MERCHANTS_FAILED,
      payload: {
        error,
      },
    });
  }
};
